export default {
  loading: state => state.loading,
  conversationId: state => state.conversationId,
  messages: state => state.messages,
  refinements: state => state.refinements,
  searchRefinements: state => state.searchRefinements,
  products: state => state.products,
  lastSearchQuery: state => state.lastSearchQuery
}